import script from "./SuccessMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&setup=true&lang=js"

import "./SuccessMessage.vue?vue&type=style&index=0&id=cc200bd2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc200bd2"]])

export default __exports__